export default class MobileNavigation {
    private readonly overlay : HTMLElement;
	private target : HTMLElement;
	private readonly toggle : HTMLElement;
	private state : string;

    public constructor( target : HTMLElement ) {
        this.target = target;
        this.overlay = document.getElementById( 'mobile-navigation-overlay' );
        this.toggle = document.getElementById( 'mobile-navigation-toggle' );
        this.state = 'closed';

        if (this.toggle && this.overlay) {
			this.toggleNavigation = this.toggleNavigation.bind( this );
			this.toggle.addEventListener( 'click', this.toggleNavigation );
			this.overlay.addEventListener( 'click', this.toggleNavigation );
		}
    }

    public toggleNavigation( event : Event ) : void {
        event.preventDefault();

        switch( this.state ) {
            case 'open':
                this.closeNavigation();
                break;
            case 'closed':
                this.openNavigation();
                break;
        }
    }

    private closeNavigation() : void {
        this.target.classList
            .remove( 'mobile-navigation--is-open' );
        this.target.classList
            .add( 'mobile-navigation--is-closed' );

        this.state = 'closed';
    }

    private openNavigation() : void {
        this.target.classList
            .remove( 'mobile-navigation--is-closed' );
        this.target.classList
            .add( 'mobile-navigation--is-open' );

        this.state = 'open';
    }

}
